module.exports = __webpack_public_path__ + "assets/normal/images/user.55eb7ef8.png";